'use strict';

var _ = require('underscore'),
    SafeLocalStorage = require('../utils/SafeLocalStorage'),
    request = require('superagent');

function randomHex() {
  return '' + Math.floor(Math.random() * 10000000000).toString(16);
}

function getFingerprint(storageKey) {
  if (!storageKey) {
    throw new Error('Fingerprint key not specified.');
  }

  var result = SafeLocalStorage.getItem(storageKey);
  if (!result) {
    result = randomHex() + randomHex() + randomHex() + randomHex();
    SafeLocalStorage.setItem(storageKey, result);
  }

  return result;
}

function getSession(storageKey) {
  if (!storageKey) {
    throw new Error('Session key not specified.');
  }

  var result;
  try {
    result = sessionStorage.getItem(storageKey);
  } catch (error) {}

  if (!result) {
    result = randomHex() + randomHex() + randomHex() + randomHex();
    try {
      sessionStorage.setItem(storageKey, result);
    } catch (error) { }
  }

  return result;
}

module.exports = {
  initialize: function (options) {
    this.backendUrl = options.backendUrl;
    this.sessionData = {
      'user_id': options.userId,
      'user_fingerprint': getFingerprint(options.fingerprintKey),
      'session': getSession(options.sessionKey),
      'timezone': new Date().getTimezoneOffset() / -60
    };
  },

  trackEvent: function (name, params) {
    if (!this.backendUrl) {
      throw new Error('Call initialize() before tracking events.');
    }

    var eventData = _.extend({
      'location': document.location.href,
      'event': name,
      'data': params
    }, this.sessionData);

    request.post(this.backendUrl).send(eventData).end();
  }
};


/** WEBPACK FOOTER **
 ** ./utils/AnalyticsClient.js
 **/